const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

const validation = module.exports = {
  isSafeString(value) {
    if(!value.match(/<[a-z][\s\S]*>/)) {
      return true;
    }
    return false;
  },
  isValidName(name) {
    if (typeof name !== 'string') return false;
    if (name.trim().length === 0) return false;
    if (name.match(/\.\w/)) return false;
    if (name.match(/[:]/)) return false;
    return validation.isSafeString(name);
  },
  isValidPw(pw) {
    if (typeof pw !== 'string') return false;
    if (pw.length < 8) return false;
    if (pw.length > 128) return false;
    if (!pw.match(/[A-Z]/)) return false;
    if (!pw.match(/[0-9]/)) return false;
    return true;
  },
  isValidEmail(email) {
    if (typeof email !== 'string') return false;
    if (!email.match(EMAIL_REGEX)) return false;
    return true;
  },
  EMAIL_REGEX,
};
